import { Button, Divider } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  sumCartItemMrpPrice,
  sumCartItemSellingPrice,
} from "../../../util/cartCalculator";
import { useAppSelector } from "../../../Redux Toolkit/Store";

const PricingCard = ({ showBuyButton, SubmitButton }: any) => {
  const navigate = useNavigate();
  const { cart, auth } = useAppSelector((store) => store);
  const totalSellingPrice = cart.cart?.totalSellingPrice || 0;
  const isFreeShipping = totalSellingPrice > 1499;
  const shippingFee = isFreeShipping ? 0 : 95;
  const finalTotal = totalSellingPrice + shippingFee;
  return (
    <div>
      <div className="space-y-3 p-5">
        <div className="flex justify-between items-center">
          <span>Subtotal</span>
          <span>₹ {cart.cart?.totalMrpPrice}</span>
        </div>
        <div className="flex justify-between items-center">
          <span>Discount</span>
          <span>
            -₹{" "}
            {sumCartItemMrpPrice(cart.cart?.cartItems || []) -
              sumCartItemSellingPrice(cart.cart?.cartItems || [])}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span>Shipping</span>
          <span className={isFreeShipping ? "text-teal-600" : ""}>
            {isFreeShipping ? "Free" : "₹ 95"}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span>Platform fee</span>
          <span className="text-teal-600">Free</span>
        </div>
      </div>
      <Divider />

      <div className="font-medium px-5 py-2 flex justify-between items-center">
        <span>Total</span>
        <span>₹ {finalTotal}</span>
      </div>
    </div>
  );
 };
//  sumCartItemSellingPrice(cart.cart?.cartItems || [])
// sumCartItemMrpPrice(cart.cart?.cartItems || [])

export default PricingCard;
